import React from 'react'
import Tooltip from '@material-ui/core/Tooltip';

export default function Tip({ placement = 'top', description }) {
  return (
    <Tooltip placement={placement} >
      {description}
    </Tooltip>)
}
